import React from 'react';
import URL from '../domain/URL';
import MarkdownComponent from './MarkdownComponent';
import { t, props } from 'tcomb-react';

@props({
  image: URL,
  description: t.Str
})
export default class StdCustomPayment extends React.Component {

  render() {
    return (
      <div>
        <div className='custom'>
          <img src={this.props.image}></img>
        </div>
        <MarkdownComponent>{this.props.description}</MarkdownComponent>
        <hr />
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/StdCustomPayment.js
 **/